/**
 * Gallery like styled lightbox component for presenting various types of media
 * @requires https://github.com/sachinchoolur/lightGallery
 */

import vendorMissing from './vendor-missing'
import onFragment, { within } from './on-fragment'

export default (() => {
  /* eslint-disable no-undef */
  const create = (el) => {
    const thumbnails = el.dataset.thumbnails ? true : false,
      video = el.dataset.video ? true : false,
      defaultPlugins = [lgZoom, lgFullscreen],
      // the optional plugins only join when their file is there - a
      // gallery without them still opens
      videoPlugin = video && typeof lgVideo !== 'undefined' ? [lgVideo] : [],
      thumbnailPlugin =
        thumbnails && typeof lgThumbnail !== 'undefined' ? [lgThumbnail] : [],
      plugins = [...defaultPlugins, ...videoPlugin, ...thumbnailPlugin]

    el._lgInstance = lightGallery(el, {
      selector: el._lgSelector || '.gallery-item',
      plugins: plugins,
      licenseKey: 'D4194FDD-48924833-A54AECA3-D6F8E646',
      download: false,
      autoplayVideoOnSlide: true,
      zoomFromOrigin: false,
      youtubePlayerParams: {
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
      },
      vimeoPlayerParams: {
        byline: 0,
        portrait: 0,
        color: '6366f1',
      },
    })
    return el._lgInstance
  }

  const missing = () =>
    vendorMissing('gallery', {
      lightGallery: typeof lightGallery,
      lgZoom: typeof lgZoom,
      lgFullscreen: typeof lgFullscreen,
    })
  /* eslint-enable no-undef */

  // Created on the first click, not on page load: lg-thumbnail builds the
  // whole thumbnail strip on init - one <img> per item, none of them lazy -
  // so a 573-photo gallery downloaded every thumbnail before anyone opened
  // it. A filter (masonry-grid.js) parks its selector in _lgSelector until
  // then.
  //
  // The libraries are looked up on that click, not here: a gallery htmx
  // swaps in (an expanded listing card, on-fragment.js) brings its own
  // <script> tags, which are still loading when this runs. Without them the
  // click is left alone and the link opens the image.
  const setup = (el) => {
    if (el._lgBound === true) return
    el._lgBound = true
    el.addEventListener('click', (e) => {
      if (el._lgInstance) return
      const item = e.target.closest('.gallery-item')
      if (item === null || !el.contains(item)) return
      if (missing()) return
      e.preventDefault()
      const instance = create(el)
      const index = Array.prototype.indexOf.call(instance.items, item)
      instance.openGallery(Math.max(index, 0))
    })
  }

  onFragment((root) => within(root, '.gallery').forEach(setup))
})()
